import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const NocService = {
    status: async (model) => axios.post(API_URL + "/noc/status", model).then(({data}) => data).catch(err => { throw err }),
    getHash: async () => axios.get(API_URL + "/cameras/dashboard/hash").then(({data}) => data).catch((err) => { throw err }),
};

export default NocService;